import cxs from 'cxs';
import { COLOURS, MEDIA_QUERIES, SHADOWS } from '../../../common/styles/vars';


// We have to use !important in these styles because Rodal sets inline styles
// which we have no way to override with cxs

const getWidth = ({ isFullWidth, isAutoWidth }) => {
  if (isFullWidth) {
    return '100%';
  }

  if (isAutoWidth) {
    return 'auto';
  }

  return 'none';
};

const getMediumWidth = ({ mediumWidth, isAutoWidth }) => {
  if (mediumWidth) {
    return `${mediumWidth}%`;
  }

  if (isAutoWidth) {
    return '60%';
  }

  return 'none';
};

const getSmallWidth = ({ isAutoWidth }) => {
  if (isAutoWidth) {
    return 'calc(100% - 10px)';
  }

  return 'none';
};

export const MODAL_CONTAINER = (options) => cxs({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',

  // We set this explicitly here because Rodal sets animation duration
  // the same for both the dialog and the overlay. Unfortunately, they
  // take different times in reality so we need to tweak this.
  animationDuration: '100ms !important',

  '> .rodal-mask': {
    background: 'rgba(0, 0, 0, 0.3);'
  },

  '> .rodal-dialog': {
    background: COLOURS.mono.white,
    borderRadius: '12px',
    padding: 0,
    marginTop: '5px',
    marginBottom: '5px',
    position: 'relative !important',
    height: 'auto !important',
    maxHeight: 'calc(100% - 10px)',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '1080px',
    minWidth: options.minWidth || '40%',
    width: `${getWidth(options)} !important`,
    boxShadow: SHADOWS.soft,

    [MEDIA_QUERIES.medium]: {
      width: `${getMediumWidth(options)} !important`
    },

    [MEDIA_QUERIES.small]: {
      width: `${getSmallWidth(options)} !important`
    }
  },

  '.base-modal--xs': {
    '> .rodal-dialog': {
      width: '400px !important',
      'max-width': '400px !important',
      'min-width': 'auto',
      [MEDIA_QUERIES.small]: {
        width: '320px !important'
      }
    }
  },

  '.base-modal--md': {
    '> .rodal-dialog': {
      width: '632px !important',
      'max-width': '632px !important',
      'min-width': 'auto',
      [MEDIA_QUERIES.small]: {
        width: '320px !important'
      }
    }
  },

  '.base-modal--sm': {
    '> .rodal-dialog': {
      width: '552px !important',
      'max-width': '552px !important',
      'min-width': 'auto',
      [MEDIA_QUERIES.small]: {
        width: '320px !important'
      }
    }
  }
});

export const MODAL = (styles = {}) => cxs({
  display: 'flex',
  height: '100%',
  overflowY: 'auto',
  flexDirection: 'column',
  padding: '40px',

  '& button': {
    height: '40px',
    minHeight: '40px'
  },

  [MEDIA_QUERIES.small]: {
    padding: '50px 20px 30px'
  },

  ...styles
});

export const CLOSE_ICON = cxs({
  cursor: 'pointer',
  position: 'absolute',
  top: '25px',
  right: '25px'
});